// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store.js";

import axios from "axios";
import router from "./router";
import "./resources/rem.js";
import Vant from "vant";
import "vant/lib/index.css";
import rsaConfig from "./rsaConfig";
//引用全局变量js
import common from '@/util/global'
Vue.prototype.Common = common;

import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);

import {Dialog} from 'vant';
import VueTypedJs from 'vue-typed-js';
Vue.use(VueTypedJs);
Vue.use(Dialog);
Vue.use(Vant);

/*监控平台 js start*/
import "../static/js/errorOnline.js";
// 前端监控平台 (必须使用axios做ajax请求) 生产环境开启。
// 初始化name 是项目名称 String类型，自定义或者使用 title默认确保绝对唯一;
// 如果不需要直接注释;
if (process.env.NODE_ENV === "production") {
    window.Vue = Vue;
    window.axios = axios;
    let name = rsaConfig.siteName;
    if (process.env.srconfig == 'dev') {
        name = `${rsaConfig.siteName} test`
    }
    window.erOnline = new window.ErOnline({
        name
    });
}
/*监控平台 js end*/

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

router.afterEach((to, from, next) => {
    console.log('---', to.meta);
    store.commit('CHANGE_TAB_BAR_STATUS', to.meta.hasTabBar);
    store.commit('CHANGE_CUSTOMER', to.meta.hasCustomer);
    document.title = to.meta.subTitle ? to.meta.subTitle : (to.meta.title ? to.meta.title : '');
});


// import vConsole from 'vconsole';
// new vConsole();

new Vue({
    el: "#app",
    router,
    store,
    components: {App},
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js